import { InputNumerico } from "app/components/inputs/InputNumerico";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { useFormik } from "formik";
import globalMU from "globalMU";
import React from "react";
import { DadosProdutosLote, Lotes } from "../produto-lote/ProdutoLote";

const estiloBotoes = require('../../../../estilos/botoes.module.scss').default

export type ProdutoLoteEditarProps = {
  dadosProdutoLote: DadosProdutosLote
  lote: Lotes;
  controlaValidade: boolean;
  onSalvar: (dados: DadosProdutosLote) => void;
};

export const ProdutoLoteEditar = (props: ProdutoLoteEditarProps) => {

  const formik = useFormik({
    initialValues: { ...props.lote },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });

  return (
    <>
    <div className="_overflow-x-auto">
      <div className="_grid _grid-cols-[min-content_auto] _items-center"
        id="ProdutoLoteEditar_DadosLote">
        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Produto</label>
        <div className="_bg-[#ffffff] _font-bold _pl-[10px] _pb-[5px]"
          id="ProdutoLoteEditar_DescricaoProduto"
        >{props.dadosProdutoLote.DescricaoProduto}</div>

        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Quantidade Pedida </label>
        <div className="_ml-1"
          id="ProdutoLoteEditar_QuantidadePedida"
        >{globalMU.formatarValorNumerico(props.dadosProdutoLote.QuantidadePedida, 3, false)}</div>

        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Quantidade Lançada </label>
        <div className="_ml-1"
          id="ProdutoLoteEditar_QuantidadeReservada"
        >{globalMU.formatarValorNumerico(props.dadosProdutoLote.QuantidadeReservada, 3, false)}</div>

        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Quantidade Faltante </label>
        <div className="_ml-1"
          id="ProdutoLoteEditar_QuantidadeFaltante"
        >{globalMU.formatarValorNumerico(props.dadosProdutoLote.QuantidadePedida - props.dadosProdutoLote.QuantidadeReservada, 3, false)}</div>

        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Lote Interno</label>
        <div className="_ml-1"
          id="ProdutoLoteEditar_LoteInterno"
        >{formik.values.LoteInterno}</div>

        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Tonalidade</label>
        <div className="_ml-1"
          id="ProdutoLoteEditar_Tonalidade"
        >{formik.values.NomeTonalidade}</div>

        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Bitola</label>
        <div className="_ml-1"
          id="ProdutoLoteEditar_Bitola"
        >{formik.values.NomeBitola}</div>

        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Fabricação</label>
        <div className="_ml-1"
          id="ProdutoLoteEditar_DataFabricacao"
        >{globalMU.formatDate(formik.values.DataFabricacao)}</div>

        {props.controlaValidade &&
          <>
            <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Validade</label>
            <div className="_ml-1" style={{ color: formik.values.LoteInterno ? 'red' : 'black' }} 
            id="ProdutoLoteEditar_Validade"
            >{globalMU.formatDate(formik.values.Validade)}</div>
          </>
        }

        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Vender Apenas Saldo	</label>
        <div className="_ml-1"
          id="ProdutoLoteEditar_VenderApenasSaldo"
        >{formik.values.VenderApenasSaldo ? "Sim" : "Não"}</div>

        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Quantidade Disponível</label>
        <div className="_ml-1"
          id="ProdutoLoteEditar_QuantidadeDisponivel"
        >{globalMU.formatarValorNumerico(formik.values.QuantidadeDisponivel)}</div>

        <label className="_w-[200px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Quantidade a Reservar</label>
        <div className="_m-1">
          <InputNumerico
            onValorModificado={(valorModificado) => formik.setFieldValue("QuantidadeReservar", valorModificado)}
            valor={formik.values.QuantidadeReservar}
            autoFocus={true}
            id="ProdutoLoteEditar_inputQuantidadeReservar"
            numeroCasasDecimais={3}
          />
        </div>
      </div>
      </div>

      <div className="_mt-4">
        <button className={estiloBotoes.botaoPrimario} onClick={() => props.onSalvar(formik.values)}
        id="ProdutoLoteEditar_BotaoSalvar">
          Salvar
        </button>
      </div>
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};